import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared';
import {
  EntityLocationDialogComponent,
  EntityLocationPopupComponent,
} from '@entities/entity-location/entity-location-dialog/entity-location-dialog.component';

@NgModule({
  declarations: [EntityLocationDialogComponent, EntityLocationPopupComponent],
  imports: [CommonModule, SharedModule],
  entryComponents: [
    EntityLocationDialogComponent,
    EntityLocationPopupComponent,
  ],
})
export class EntityLocationModule {}
